import React, { Component } from 'react';
import './shelf-featured-banner.css';
import Sdk from 'api.digitalpages.module.sdk.api';
import AuthorService from '../../services/AuthorService';
import FoodStyling from "./food-styling.png";

const CACHE_KEY = 'shelf_featured_banner_cache';

export default class ShelfFeaturedBanner extends Component {
  constructor(props) {
    super(props);

    const cached = this.loadFromCache();
    this.state = {
      featured_book: cached?.featured_book || null,
      loading: !cached,
      authors: cached?.authors || [],
    };
  }

  componentDidMount() {
    this.getFeaturedPublication();
  }

  loadFromCache() {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  saveToCache(data) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify(data));
    } catch {
      // localStorage cheio ou indisponível
    }
  }

  isEqual(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
  }

  redirectTo(path) {
    window.location = window.location.origin + window.location.pathname + "#" + path;
  }

  activate = () => {
    if (this.state.featured_book) {
      this.redirectTo(`/content/uid/${this.state.featured_book.uid}/detail`);
    }
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.activate();
    }
  };

  async getFeaturedPublication() {
    if (!this.state.featured_book) {
      this.setState({ loading: true });
    }

    const baseURL = 'cms/v1.1/managed/content/available';
    const urlParams = new URLSearchParams({
      include_properties: true,
      include_entities: true,
      include_references: true,
      order_published: 'desc',
      page_size: 1,
    });

    const urlFeatured = `${baseURL}?${urlParams.toString()}`;

    const [authors, response] = await Promise.all([
      AuthorService.loadAuthors(),
      Sdk.Api.dynamic.bridge(urlFeatured, null, 'GET'),
    ]);

    const book = response?.result?.[0];
    console.log('Featured book:', book);
    if (book) {
      book.author = this.getBookAuthor(book, authors);
    }

    // const test = await Sdk.Api.dynamic.bridge(`cms/v1.1/managed/content/group/uid/${book.uid}`, null, "GET")
    // console.log("test", test)

    const newData = { featured_book: book, authors };
    const oldData = this.loadFromCache();

    if (!oldData || !this.isEqual(oldData, newData)) {
      this.saveToCache(newData);
      this.setState({
        featured_book: book,
        authors,
        loading: false,
      });
    } else {
      this.setState({ loading: false });
    }
  }

  getBookAuthor(book, authors) {
    let author = book.properties?.find(p =>
      p.name === "Autor" ||
      p.name === "autor" ||
      p.name === "Author" ||
      p.name === "AUTOR"
    )?.value;

    if (!author && book.entities && authors.length) {
      author = AuthorService.updateContentAuthor(book, authors);
    }

    if (!author || author === 'Autor não disponível') {
      author = book.author ||
        book.properties?.find(p => p.name.toLowerCase().includes('autor'))?.value ||
        '';
    }

    return author;
  }

  getImageUrl(uid) {
    return `${Sdk.Api.domain}/cms/v1.1/managed/content/group/uid/${uid}/default/thumb/v2?image_options=width:400&api_env=${Sdk.Api.enviroment}&project_key=${Sdk.Api.projectKey}&access_token=${Sdk.Api.authorization.credential.accessToken}`;
  }

  render() {
    const { featured_book, loading } = this.state;

    if (loading) {
      return (
        <>
          <div className="shelf-featured-banner">
            <div className="shelf-featured-banner-skeleton">
              <div className="shelf-featured-banner-skeleton-cover" />
            </div>
            <div className="shelf-featured-banner-info">
              <div className="shelf-featured-banner-skeleton">
                <div className="shelf-featured-banner-skeleton-tag" />
                <div className="shelf-featured-banner-skeleton-title" />
                <div className="shelf-featured-banner-skeleton-description" />
                <div className="shelf-featured-banner-skeleton-description shelf-featured-banner-skeleton-description-short" />
                <div className="shelf-featured-banner-skeleton-author" />
              </div>
            </div>
          </div>
        </>
      );
    }

    const bookName = featured_book?.name || 'Food Styling';
    const bookDescription = featured_book ? featured_book.description : 'Manual prático de produção gastronômica para foto e vídeo';
    const bookAuthor = featured_book ? featured_book.author : 'Juliano Albano, João Martins Portelinha Neto';
    const imageUrl = featured_book?.uid ? this.getImageUrl(featured_book.uid) : FoodStyling;

    return (
      <div className="shelf-featured-banner-container">
        <div className="shelf-featured-banner" >
          <div
            className="shelf-featured-banner-cover"
            role="button"
            tabIndex={0}
            aria-label={bookName}
            onClick={this.activate}
            onKeyDown={this.handleKeyDown}
          >
            <img className="shelf-featured-banner-cover-img" src={imageUrl} alt={`Capa do livro ${bookName}`} />
          </div>
          <div
            className="shelf-featured-banner-info"
            role="button"
            tabIndex={0}
            aria-label={bookName}
            onClick={this.activate}
            onKeyDown={this.handleKeyDown}
          >
            <div className="shelf-featured-banner-info-tag" role="heading" aria-level="2">Lançamento</div>
            <div className="shelf-featured-banner-info-title">{bookName}</div>
            <div className="shelf-featured-banner-info-description">{bookDescription}</div>
            <div className="shelf-featured-banner-info-author">{bookAuthor}</div>
          </div>
        </div>
      </div>
    );
  }
}
